module.exports = __webpack_public_path__ + "img/terroir-grid-1.e5ebd590.jpg";